import axios from "axios";

import {
  CreateSuppressionAudienceData,
  SuppressionAudience,
  SuppressionAudienceMetadata,
  SuppressionAudienceSyncedContact,
} from "../types/suppression-audience";

export const getSuppressionAudienceMetadata = async (
  workspaceSlug: string,
): Promise<SuppressionAudienceMetadata> => {
  return (
    await axios.get(
      `/api/v1/workspaces/${workspaceSlug}/suppression-audiences/metadata`,
    )
  ).data;
};

export const getSuppressionAudiences = async (
  workspaceSlug: string,
): Promise<SuppressionAudience[]> => {
  return (
    await axios.get(`/api/v1/workspaces/${workspaceSlug}/suppression-audiences`)
  ).data;
};

export const getSuppressionAudience = async (
  workspaceSlug: string,
  id: number,
): Promise<SuppressionAudience> => {
  return (
    await axios.get(
      `/api/v1/workspaces/${workspaceSlug}/suppression-audiences/${id}`,
    )
  ).data;
};

export const createSuppressionAudience = async (
  workspaceSlug: string,
  data: CreateSuppressionAudienceData,
): Promise<SuppressionAudience> => {
  return (
    await axios.post(
      `/api/v1/workspaces/${workspaceSlug}/suppression-audiences`,
      data,
    )
  ).data;
};

export const getSuppressionAudienceSyncedContacts = async (
  workspaceSlug: string,
  id: number,
): Promise<SuppressionAudienceSyncedContact[]> => {
  return (
    await axios.get(
      `/api/v1/workspaces/${workspaceSlug}/suppression-audiences/${id}/synced-contacts`,
    )
  ).data;
};

export const deleteSuppressionAudience = async (
  workspaceSlug: string,
  id: number,
): Promise<void> => {
  await axios.delete(
    `/api/v1/workspaces/${workspaceSlug}/suppression-audiences/${id}`,
  );
};
